"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeRect = void 0;
/**
 * @description width/heightを非負の値になるように正規化を行う．
 * （リサイズの結果，widthやheightが負の値になったRectが生成されることがある）
 */
var normalizeRect = function (rect) {
    return rect.withMutations(function (r) {
        var w = r.width;
        var h = r.height;
        if (w < 0) {
            r.set('width', -w).update('left', function (l) { return l + w; });
        }
        if (h < 0) {
            r.set('height', -h).update('top', function (t) { return t + h; });
        }
    });
};
exports.normalizeRect = normalizeRect;
